import Vue from 'vue'
import VueCalendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

Vue.component('VueCalendar', VueCalendar)
Vue.component('DatePicker', DatePicker)

export default {
  components: {
    VueCalendar,
    DatePicker,
  },
}
